const awsConfig = {
    aws_project_region: "ap-southeast-2",
    aws_appsync_region: "ap-southeast-2",
    aws_cognito_region: "ap-southeast-2",
    aws_user_pools_id: "ap-southeast-2_IYv2pYJAj",
    aws_user_pools_web_client_id: "2ab1u3l1jrdeareen44gt28phs",
    oauth: {
      domain: "practitioner.auth.ap-southeast-2.amazoncognito.com",
      scope: [
          "openid",
          "profile"
      ],
      redirectSignIn: "https://practitioner.mydna.life/welcome",
      redirectSignOut: "https://practitioner.mydna.life/end",
      responseType: "code"
    },
    federationTarget: "COGNITO_USER_POOLS"
  };
  export default awsConfig;